import React from "react";

import i18next from 'i18next';

import iOSBadge from '../images/badge-ios-es.png'
import androidBadge from '../images/bagde-android-es.png'
import iOSBadgeEN from '../images/badge-ios-en.png'
import androidBadgeEN from '../images/bagde-android-en.png'

export default function StoreButtons() {
    var lng = i18next.language

    if (lng === "es") {
        return (
            <div>
                <p className="color-lavander">Próximamente</p>
                <div className="c-storebuttons">
                    <img src={androidBadge} alt="Playstore" height={56} />
                    <img src={iOSBadge} alt="AppStore" height={56} />
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <p className="color-lavander">Coming soon</p>
                <div className="c-storebuttons">
                    <img src={androidBadgeEN} alt="Playstore" height={56} />
                    <img src={iOSBadgeEN} alt="AppStore" height={56} />
                </div>
            </div>
        );
    }

    // if (lng === "es") {
    //     return (
    //         <div className="c-storebuttons">
    //             <a href="https://play.google.com/store/apps/details?id=com.monetta" target="_blank" rel="noreferrer" >
    //                 <img src={androidBadge} alt="Playstore" height={56} />
    //             </a>
    //             <a href="https://apps.apple.com/co/app/monetta/id1567809169?l=es" target="_blank" rel="noreferrer" >
    //                 <img src={iOSBadge} alt="AppStore" height={56} />
    //             </a>
    //         </div>
    //     );
    // } else {
    //     return (
    //         <div className="c-storebuttons">
    //             <a href="https://play.google.com/store/apps/details?id=com.monetta" target="_blank" rel="noreferrer" >
    //                 <img src={androidBadgeEN} alt="Playstore" height={56} />
    //             </a>
    //             <a href="https://apps.apple.com/co/app/monetta/id1567809169?l=es" target="_blank" rel="noreferrer" >
    //                 <img src={iOSBadgeEN} alt="AppStore" height={56} />
    //             </a>
    //         </div>
    //     );
    // }
}